import { render, staticRenderFns } from "./RealEstateCalculator.vue?vue&type=template&id=c0b7a756"
import script from "./RealEstateCalculator.vue?vue&type=script&lang=ts"
export * from "./RealEstateCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports